import { Button, cn } from '@repo/ui';
import { Trash2 } from 'lucide-react';
import type { ReactElement } from 'react';

interface DeleteButtonProps {
  /** 버튼 이름. iconOnly 면 글자 없이 aria-label·title 로만 쓴다. */
  readonly label: string;
  /** 휴지통 아이콘만 보이는 작은 버튼(목록 줄 안). */
  readonly iconOnly?: boolean;
  readonly disabled?: boolean;
  /** 마우스를 올리면 보이는 설명(꺼진 사유 등). */
  readonly title?: string;
  readonly onClick: () => void;
}

/**
 * 사이드바의 모든 삭제 버튼 — 빨간 테두리·글자의 휴지통 버튼 하나로 통일한다. 제목 옆에 놓도록 작게 만든다.
 */
export const DeleteButton = ({
  label,
  iconOnly = false,
  disabled = false,
  title,
  onClick,
}: DeleteButtonProps): ReactElement => (
  <Button
    type="button"
    variant="outline"
    size={iconOnly ? 'icon' : 'sm'}
    aria-label={iconOnly ? label : undefined}
    title={title ?? (iconOnly ? label : undefined)}
    disabled={disabled}
    onClick={onClick}
    className={cn(
      'shrink-0 border-destructive/40 text-destructive hover:bg-destructive/10 hover:text-destructive',
      iconOnly ? 'size-7' : 'h-7 gap-1 px-2 text-xs',
    )}
  >
    <Trash2 aria-hidden />
    {iconOnly ? null : label}
  </Button>
);
